function n(n,t){const o={};for(const l of n){const n=l[t]??null;null!==n&&(o[String(n)]=l)}return o}export{n as default};
